import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { PrimaryButton, SecondaryButton, TextField } from '../../components/AtomComponents';
import { IFederatedLoginFormProps } from './types';

export const FederatedLoginForm: React.FC<IFederatedLoginFormProps> = ({
  formState: { formData, showApiKey, loading, loginUrl, isValid },
  handlers: { setShowApiKey, handleFieldChange, handleReset },
  onSubmit,
}) => (
  <form onSubmit={onSubmit} autoComplete="off">
    <div className="form-row">
      <label className="form-label" htmlFor="jira-ticket-input">Jira Ticket:</label>
      <TextField
        id="jira-ticket-input"
        className="form-input"
        size="small"
        placeholder="Enter Jira Ticket (e.g. SP-1235)"
        value={formData.jiraTicket}
        onChange={handleFieldChange('jiraTicket')}
        disabled={loading}
        autoComplete="off"
      />
    </div>

    <div className="form-row">
      <label className="form-label" htmlFor="summary-input">Summary of the ticket:</label>
      <TextField
        id="summary-input"
        className="form-input px-resizable-textarea"
        size="small"
        placeholder="Enter summary of the ticket"
        multiline
        value={formData.summary}
        onChange={handleFieldChange('summary')}
        disabled={loading}
        autoComplete="off"
        inputProps={{ maxLength: 250 }}
        helperText={`${formData.summary.length}/250 characters`}
      />
    </div>

    <div className="form-row">
      <div className="form-label-header">
        <label className="form-label" htmlFor="api-key-input">API Key:</label>
        <Tooltip title={showApiKey ? 'Hide API Key' : 'Show API Key'} placement="top" arrow classes={{ popper: 'pxw-tooltip-popper' }}>
          <IconButton aria-label="toggle api key visibility" onClick={() => setShowApiKey(!showApiKey)} size="small" className="visibility-toggle-btn">
            {showApiKey ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" color="primary" />}
          </IconButton>
        </Tooltip>
      </div>
      <TextField
        id="api-key-input"
        className={`form-input px-resizable-textarea api-key-input ${showApiKey ? 'is-unmasked' : 'is-masked'}`}
        size="small"
        multiline
        placeholder="Enter API Key"
        value={formData.apiKey}
        onChange={handleFieldChange('apiKey')}
        disabled={loading}
        autoComplete="new-password"
      />
    </div>

    <div className="form-actions">
      <PrimaryButton type="submit" disabled={!isValid || loading} onClick={onSubmit}>
        {loading ? 'Generating URL...' : 'Submit'}
      </PrimaryButton>
      {loginUrl && (
        <SecondaryButton onClick={handleReset} disabled={loading}>
          Clear Result
        </SecondaryButton>
      )}
    </div>
  </form>
);
